import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Tracks from './pages/Tracks';
import Gallery from './pages/Gallery';
import Pricing from './pages/Pricing';
import Registration from './pages/Registration';
import Demo from './pages/Demo';
import SummerCamp from './pages/SummerCamp';
import GreaterNoidaCamp from './pages/GreaterNoidaCamp';
import RegistrationNoida from './pages/RegistrationNoida';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tracks" element={<Tracks />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/register" element={<Registration />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/summer-camp" element={<SummerCamp />} />
            <Route path="/greater-noida" element={<GreaterNoidaCamp />} />
            <Route path="/register-noida" element={<RegistrationNoida />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
